export enum WaterDetailFields {
    WaterSupplier = 'waterSupplier',
    NationalRegistrationNumber = 'nationalRegistrationNumber',
    MeterNumber = 'meterNumber',
    MeterReading = 'meterReading',
    leaverFilingOptionId = 'leaverFilingOptionId',
    LeaverContactAddress = 'leaverContactAddress',
    TransferDocumentComplete = 'transferDocumentComplete',
    LeaverFinalInvoiceByPost = 'leaverFinalInvoiceByPost',
    MovingDate = 'movingDate',
}
